<template>
  <v-container id="regular-tables" fluid tag="section">
    <v-row>
      <v-col sm="12" v-if="loading">
        <v-row>
          <v-col cols="4">
            <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
          </v-col>
          <v-col cols="4">
            <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
          </v-col>
          <v-col cols="4">
            <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>

      <v-col sm="12" v-if="!loading">
        <v-row>
          <v-col cols="4" v-for="avPlan in plans" :key="avPlan.id">
            <base-material-stats-card
              :color="plan.id == avPlan.id ? 'primary' : 'grey'"
              icon="mdi-calendar-multiple"
              :title="avPlan.nickname"
              :value="`R ${ (avPlan.amount/100).toFixed(2) }`"
              sub-icon="mdi-repeat"
              :sub-text="`Billed every ${ avPlan.interval_count } ${ avPlan.interval }${ avPlan.interval_count > 1 ? 's' : '' }`"
            >
              <v-card-actions>
                <v-spacer />

                <v-icon
                  x-large
                  class="card-icon primary--text"
                  v-if="avPlan.id == plan.id"
                >mdi-checkbox-marked-outline</v-icon>
                <v-btn color="primary" @click="setPlan(avPlan)" v-if="avPlan.id != plan.id">Select</v-btn>
                <v-spacer />
              </v-card-actions>
            </base-material-stats-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <!-- <card class='stripe-card'
        ref="cardElement"
        :class='{ complete }'
        stripe='pk_test_CptxrW4cH5MjfOzqOBgSp9Lt00CfPnde1R'
        :options='stripeOptions'
        @change='complete = $event.complete'
      />-->
      <v-col cols="12">
        <!-- <base-material-card 
          v-if="selectPlan"
          color="primary"
          icon="mdi-calendar-multiple"
          :title="selectPlan.nickname"
          :value="`R ${ (selectPlan.amount/100).toFixed(2) }`"
          sub-icon="mdi-repeat"
          :sub-text="`Billed every ${ selectPlan.interval_count } ${ selectPlan.interval }${ selectPlan.interval_count > 1 ? 's' : '' }`"
        >-->
        <base-material-card
          icon="mdi-credit-card"
          color="primary"
          title="Payment Information"
          class="px-5 py-1"
        >
          <v-row>
            <v-col cols="5">
              <v-row>
                <v-col cols="4" class="pb-0">
                  <div class="display-2 font-weight-light">Price</div>
                </v-col>
                <v-col cols="7" class="text-right pb-0">
                  <h3
                    class="display-2 font-weight-light"
                    v-text="`R ${ (plan.amount/100).toFixed(2) }`"
                  ></h3>
                  <span
                    class="grey--text"
                    v-text="`Every ${ plan.interval_count } ${ plan.interval }${ plan.interval_count > 1 ? 's' : '' }`"
                  ></span>
                </v-col>
                <v-col cols="4" class="pb-0">
                  <div class="display-2 font-weight-light">Total</div>
                </v-col>
                <v-col cols="7" class="text-right pb-0">
                  <h3
                    class="display-2 font-weight-light"
                    v-text="`R ${ ((plan.amount - (voucher ? voucher.amount_off : 0))/100).toFixed(2) }`"
                  ></h3>
                  <span class="grey--text">To pay today</span>
                </v-col>
                <v-col cols="12" class="text-right py-0 my-0">
                  <v-text-field
                    label="Voucher Code"
                    hint="Have a voucher/discount code?"
                    v-model="voucherCode"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        color="secondary"
                        text
                        :disabled="!voucherCode"
                        @click="applyVoucher"
                        :loading="busyVoucher"
                      >Apply</v-btn>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1">
              <v-divider vertical />
            </v-col>
            <v-col cols="6">
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    label="Name"
                    value="R"
                    hint="Your name as it appears on the card"
                    v-model="name"
                  />
                </v-col>
                <v-col cols="12">
                  <card
                    class="stripe-card"
                    :class="{ complete }"
                    stripe="pk_test_CptxrW4cH5MjfOzqOBgSp9Lt00CfPnde1R"
                    :options="stripeOptions"
                    @change="complete = $event.complete"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="pay" :loading="busy" disabled="true">Pay</v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import firebase from "firebase/app";
import { mapState, mapActions, mapMutations } from "vuex";
import { Card, createPaymentMethod } from "vue-stripe-elements-plus";
export default {
  data() {
    return {
      name: "",
      voucherCode: "",
      complete: false,
      busy: false,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details      plan_GHU5w2KigxV0IC
        // hidePostalCode: true,
        style: {
          base: {
            color: "#3c4858",
            //fontWeight: 600,
            fontFamily: "Roboto, sans-serif",
            fontSize: "1.5625rem",
            fontWeight: "300",
            fontSmoothing: "antialiased",
            ":focus": {
              color: "#3c4858"
            },

            "::placeholder": {
              color: "#3c4858"
            },

            ":focus::placeholder": {
              color: "#3c4858"
            }
          },
          invalid: {
            color: "#3c4858",
            ":focus": {
              color: "#FA755A"
            },
            "::placeholder": {
              color: "#FFCCA5"
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapState("Subscriptions", [
      "plan",
      "plans",
      "loading",
      "subscriptions",
      "invoices",
      "notSubscribed",
      "busyVoucher",
      "voucher"
    ]),
    ...mapState("User", ["user"]),
    ...mapState("Profile", ["profile"])
  },
  methods: {
    ...mapActions("Subscriptions", ["loadPlans", "loadVoucher"]),
    ...mapMutations("Subscriptions", ["setPlan"]),
    ...mapMutations("Ui", ["showSnackbar"]),
    applyVoucher() {
      this.loadVoucher(this.voucher).catch(() => {
        this.showSnackbar({
          snackbarType: "error",
          snackbarMessage:
            "Voucher not found. Please check the code and try again"
        });
      });
    },
    async pay() {
      // CLOSE YOUR EYES AND MOVE ALONG!
      this.busy = true;
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      //createToken().then(data => console.log(data.token))
      const plan = this.plan;
      const createSubscription = firebase
        .functions()
        .httpsCallable("subscribePlan");
      // const confirmPayment = firebase
      //   .functions()
      //   .httpsCallable("confirmPayment");
      // eslint-disable-next-line no-undef
      const stripe = Stripe("pk_live_BYCSlnRCrCn98D4KQMpYhSLF00S7za3cEb");
      const uid = this.user.id;
      const customerId = this.profile.s;
      const payment_error_message = this.payment_error_message;
      const show_payment_error = this.show_payment_error;
      const show_payment_success = this.show_payment_success;
      let that = this;
      // TODO: Check if the payment method already exists first!!
      createPaymentMethod("card", {
        type: "card",
        //card: this.$refs.cardElement,
        billing_details: {
          name: this.name,
          email: this.user.email
        }
      })
        .then(async function(result) {
          // Handle result.error or result.paymentMethod
          //console.log(result.paymentMethod)

          if (result.error) {
            //alert('ERROR: '+result.error);
            payment_error_message(result.error.message);
            //that.toTop();
            show_payment_error(true);
          } else {
            // Functions => create subscription
            //{ paymentMethod: result.paymentMethod, plan: this.subscription}
            await createSubscription({
              paymentMethod: result.paymentMethod,
              plan: plan,
              customerId: customerId,
              uid: uid,
              coupon: that.voucher.id
            })
              .then(async result => {
                const { latest_invoice } = result.data;
                const { payment_intent } = latest_invoice;
                if (payment_intent) {
                  const { client_secret, status } = payment_intent;

                  if (
                    status === "requires_action" ||
                    status === "requires_payment_method"
                  ) {
                    //confirmPaymentIntent(client_secret).then(function(result) {
                    //confirmPayment(client_secret)
                    await stripe
                      .confirmCardPayment(client_secret)
                      .then(result => {
                        if (result.error) {
                          // Display error message in your UI.
                          // The card was declined (i.e. insufficient funds, card has expired, etc)
                          //alert(result.error.message)
                          // payment_error_message(result.error.message);
                          show_payment_error(result.error.message);
                          //that.toTop();
                          console.error(result.error);
                        } else {
                          // Show a success message to your customer

                          // payment_error_message(null);
                          show_payment_success();
                          that.paid = true;

                          that.loadSubscriptions(customerId);
                          that.loadInvoices(customerId);
                          setTimeout(() => {
                            that.$router.push("/dashboard/index");
                          }, 1500);
                          //alert('success')
                        }
                      });
                  } else {
                    // No additional information was needed
                    // Show a success message to your customer
                    // payment_error_message(null);
                    show_payment_success();

                    that.loadSubscriptions(customerId);
                    that.loadInvoices(customerId);
                    that.paid = true;
                    setTimeout(() => {
                      that.$router.push("/dashboard/index");
                    }, 1500);
                  }
                } else {
                  if (latest_invoice.status == "paid") {
                    // payment_error_message(null);
                    show_payment_success();
                    that.paid = true;
                    setTimeout(() => {
                      that.$router.push("/dashboard/index");
                    }, 1500);
                  }
                }
              })
              .catch(err => {
                // payment_error_message(err.message);
                //that.toTop();
                show_payment_error(err.message);
              });
          }
        })
        .catch(err => {
          // payment_error_message(err.message);
          //that.toTop();
          show_payment_error(err.message);
        })
        .finally(() => (this.busy = false));
    }
  },
  mounted() {
    this.loadPlans().catch(() => {
      this.showSnackbar({
        snackbarType: "error",
        snackbarMessage:
          "There was an error loading our available subscriptions"
      });
    });
    this.name = this.user.name;
  },
  components: { Card }
};
</script>

<style scoped>
#pricing-layout {
  padding: 50px 0px;
}

.pricing-signup {
  margin-top: 20px;
}

.card-text {
  color: white;
}

.wrap-right {
  width: 100%;
  height: 188px;
  position: absolute;
  top: -8px;
  left: 8px;
  overflow: hidden;
}

.wrap-left {
  width: 100%;
  height: 188px;
  position: absolute;
  top: -8px;
  left: -8px;
  overflow: hidden;
}

.wrap-straight {
  width: 106%;
  height: 188px;
  position: absolute;
  top: -8px;
  left: -3%;
  overflow: hidden;
}

.wrap-left:before,
.wrap-left:after,
.wrap-right:before,
.wrap-right:after,
.wrap-straight:before,
.wrap-straight:after {
  content: "";
  position: absolute;
}

.wrap-right:before {
  width: 40px;
  height: 8px;
  right: 100px;
  background: #4d6530;
  border-radius: 8px 8px 0px 0px;
}

.wrap-left:before {
  width: 40px;
  height: 8px;
  left: 100px;
  background: #4d6530;
  border-radius: 8px 8px 0px 0px;
}

.wrap-straight:before {
  width: 3%;
  height: 8px;
  left: 0px;
  top: 70px;
  background: #4d6530;
  border-radius: 0px 0px 0px 8px;
}

.wrap-right:after {
  width: 8px;
  height: 40px;
  right: 0px;
  top: 100px;
  background: #4d6530;
  border-radius: 0px 8px 8px 0px;
}

.wrap-left:after {
  width: 8px;
  height: 40px;
  left: 0px;
  top: 100px;
  background: #4d6530;
  border-radius: 0px 8px 0px 8px;
}

.wrap-straight:after {
  width: 3%;
  height: 8px;
  right: 0px;
  top: 70px;
  background: #4d6530;
  border-radius: 0px 0px 8px 0px;
}

.ribbon-primary {
  width: 200px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 30px;
  z-index: 2;
  overflow: hidden;
  border: 1px dashed;
  text-align: center;
  box-shadow: 0 0 0 3px #f7be21, 0px 21px 5px -18px rgba(0, 0, 0, 0.6);
  background: #f7be21;
}

.ribbon-right {
  right: -50px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.ribbon-left {
  left: -50px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.ribbon-straight {
  top: 50px;
}

.ribbon-secondary {
  width: 102%;
  left: -1%;
  height: 40px;
  line-height: 40px !important;
  position: absolute;
  top: 30px;
  z-index: 2;
  overflow: hidden;
  border: 1px dashed;
  text-align: center;
  box-shadow: 0 0 0 3px #5fc5c2, 0px 21px 5px -18px rgba(0, 0, 0, 0.6);
  background: #5fc5c2;
}
</style>